<template>
  <div>
    <div v-show="loading" class="loading_box" :class="{fade_out:fadeOutFlag}">
      <img style="width: 120px;margin: 15% auto 30px;display: block;" src="@/assets/loading_logo.png" />
      <div style="color: #77a4d4;font-size: 16px;text-align: center;">弈客鹰眼5.0正在加载中</div>
    </div>

    <div v-show="createPDFFlag" style="position: fixed;width: 100%;height: 100%;z-index: 999;opacity: 0.9;background-color: #fff;">
      <div style="text-align: center;margin-top: 60px;">
        <img src="@/assets/pdf/hawkeye.jpg" style="width: 180px;height: 180px;">
        <div class="indexInfoDiv">
          <div style="font-size: 30px;margin-top: 15px;">弈客鹰眼5.0智能棋评</div>
          <div style="margin-top: 40px;font-size: 15px;line-height: 26px;">
            <div>{{text}}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 70px;background-color: #f2f2f2;position: relative;">
      <img style="position: fixed;right: 0px;top: 0px; width: 30px;z-index: 990;" v-if="reportType==0" src="@/assets/xiaotian.png">
      <img style="position: fixed;right: 0px;top: 0px;width: 30px;z-index: 990;" v-if="reportType==1" src="@/assets/yingyan.png">
      <div v-if="scoreFlag" class="scoreResult">
        <div style="margin: 10px 0px 10px 0px;"><span>{{scoreResult.km }}</span> <span>{{scoreResult.rate}}</span>
        </div>
        <div>{{scoreResult.result}}</div>
      </div>
      <div ref="game_info" class="game_info">
        <div class="game_info_detail flex space-between">
          <div style="position: relative;">
            <img style="position: absolute;right: 0px;bottom: 0px;" class="img" src="@/assets/blackstone.png">
            <img v-if="move.b_rate>30" src="@/assets/head/bhead3.png" class="head">
            <img v-else-if="move.b_rate>10" src="@/assets/head/bhead2.png" class="head">
            <img v-else src="@/assets/head/bhead1.png" class="head">
          </div>
          <div style="flex-grow:1;padding: 0px 10px;">
            <div class="flex space-between align-center">
              <div class="flex align-center" style="width: 30%;">
                <span class="fs14 fwb">{{bPlayer}}</span>
              </div>
              <div :style="{'background-color': getStdevC(move.score_stdev)}" class="fs12 fuzadu"> {{'复杂度 ' +move.score_stdev.toFixed(1)}}</div>
              <div class="flex align-center" style="width: 30%;justify-content: flex-end;">
                <span class="fs14 fwb">{{wPlayer}}</span>
              </div>
            </div>
            <div class="flex space-between fs12" style="padding:2px 0px">
              <div class="flex align-center"><span>提{{bRemoveCount}}子</span></div>
              <div>{{curPath}}手/{{allPath}}·{{gResult}}</div>
              <div class="flex align-center"><span>提{{wRemoveCount}}子</span></div>
            </div>

          </div>
          <div style="position: relative;">
            <img v-if="move.w_rate>30" src="@/assets/head/whead3.png" class="head">
            <img v-else-if="move.w_rate>10" src="@/assets/head/whead2.png" class="head">
            <img v-else src="@/assets/head/whead1.png" class="head">

            <img style="position: absolute;left: 0px;bottom: 0px;" class="img" src="@/assets/whitestone.png">
          </div>
        </div>
        <div class="vs-line flex space-between cf">
          <template v-if="move.w_rate!=100">
            <div class="vs-line-l" :class="{'vs-line-l100':move.b_rate==100}" :style="{width:move.b_rate+'%'}">
              <template v-if="move.b_rate>10">
                {{move.b_rate.toFixed(1)}}
              </template>
            </div>
          </template>
          <template v-if="move.b_rate!=100">
            <div class="vs-line-r" :class="{'vs-line-r100':move.w_rate==100}" :style="{width:move.w_rate+'%'}">
              <template v-if="move.w_rate>10">
                {{move.w_rate.toFixed(1)}}
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="board_content">
      <div id="board" class="board"></div>
    </div>

    <div class="echarts_div">
      <div class="tab_title fs12 fwb">
        <span  @click="openChart(6)" :class="{tab_active:tabActive==6}">选点</span>
        <span v-if="reportType!=2 || app_key=='golinks_sgfbank'" @click="openChart(1)" :class="{tab_active:tabActive==1}">走势</span>
        <span v-if="reportType!=2 && app_key!='golinksmallnew'" @click="openChart(2)" :class="{tab_active:tabActive==2}">恶手</span>
        <span v-if="reportType!=2 && app_key!='golinksmallnew'" @click="openChart(3)" :class="{tab_active:tabActive==3}">吻合度</span>
        <span v-if="reportType==1" @click="openChart(4)" :class="{tab_active:tabActive==4}">评分</span>
        <span v-if="reportType==1" @click="openChart(5)" :class="{tab_active:tabActive==5}">稳定性</span>
        <span v-if="reportType==1" @click="openChart(8)" :class="{tab_active:tabActive==8}">复杂度</span>
        <span v-if="reportType==2" @click="openChart(7)" :class="{tab_active:tabActive==7}">疑问手</span>
        <span v-if="reportType==2 && app_key!='golinks_sgfbank'" @click="openChart(9)" :class="{tab_active:tabActive==9}">好手报告</span>
      </div>
      <div class="tab_content">
        <div style="height: 150px;width: 100%;" v-show="tabActive==6">
          <div ref="recommend" class="recommend">
            <div class="row flex space-between fs12" style="background-color: #ffffff">
              <div>推荐选点</div>
              <div>领先(目)</div>
              <div>胜率(%)</div>
            </div>
            <div style="border-top: 1px solid #f2f2f2;"></div>
            <template v-bind:key="item" v-for="(item) in recommendStone">
              <div @click="recommendStoneTop(item)" v-on:mouseover="changeActive(item)" v-on:mouseout="removeActive(item)" :class="{recommendStoneSelected:recommendStoneSelected==item.stone}" class="row flex space-between fw3 align-center ">
                <div class="flex align-center ">
                  <template v-if="item.color==1">
                    <img style="width: 15px;" src="@/assets/blackstone.png">
                  </template>
                  <template v-else>
                    <img style="width: 15px;" src="@/assets/whitestone.png">
                  </template>
                  <span class=" fs12" style="margin-left: 5px; width: 30px;">{{item.stone}}</span>
                  <div v-if="item.mark" style="position: relative">
                    <div class="shizhan" :style="{'background-color': colorList[item.level]}">
                      {{item.mark}}
                    </div>
                  </div>
                </div>
                <div style="text-align: center;">
                  <template v-if="item.color==1">
                    <div v-if="item.an_result>0" style="background-color: black;color:#fff;height: 14px;width: 50px;border-radius: 3px;margin: auto;line-height: 14px;">
                      {{Math.abs(item.an_result)}}</div>
                    <div v-else-if="item.an_result<0" class="bgwhite" style="color: black;height: 14px;width: 50px;border-radius: 3px;margin: auto;line-height: 14px;border: 1px solid black">
                      {{Math.abs(item.an_result)}}</div>
                    <div v-else>0.0</div>
                  </template>
                  <template v-else>
                    <div v-if="-item.an_result>0" class="bgwhite" style="color: black;height:14px;width: 50px;border-radius: 3px;margin: auto;line-height: 14px;border: 1px solid black">
                      {{Math.abs(item.an_result)}}</div>
                    <div v-else-if="-item.an_result<0" style="background-color: black;color: #fff;height: 14px;width: 50px;border-radius: 3px;margin: auto;line-height: 14px;">
                      {{Math.abs(item.an_result)}}</div>
                    <div v-else>0.0</div>
                  </template>
                </div>
                <div>
                  <div class="vs-line flex space-between fs12 cf">
                    <div class="vs-line-l" style="width: 50%;">{{item.b_rate.toFixed(1)}}</div>
                    <div class="vs-line-r" style="width: 50%;">{{item.w_rate.toFixed(1)}}</div>
                  </div>
                </div>
              </div>
              <div style="border-top: 0.5px solid #eaeaea;"></div>
            </template>
          </div>
        </div>
        <!-- 走势图 -->
        <div style="height: 150px;width: 100%;" v-show="tabActive==1" id="chartTrend"></div>
        <!-- 恶手 -->
        <div class="flex" style="height: 150px;" v-show="tabActive==2">
          <div class="btn" style="width: 18%;position: relative;">
            <div>
              <span @click="boardTypeChange(0)" :class="{tab_active:boardType==0}">全盘</span>
              <span @click="boardTypeChange(1)" :class="{tab_active:boardType==1}">布局</span>
              <span @click="boardTypeChange(2)" :class="{tab_active:boardType==2}">中盘</span>
              <span @click="boardTypeChange(3)" :class="{tab_active:boardType==3}">官子</span>
            </div>
            <div>
              <span @click="playerTypeChange(0)" :class="{tab_active:playerType==0}">双方</span>
              <span @click="playerTypeChange(1)" :class="{tab_active:playerType==1}">黑方</span>
              <span @click="playerTypeChange(2)" :class="{tab_active:playerType==2}">白方</span>
            </div>
          </div>
          <div id="badHand" style="width: 82%;height: 150px;"></div>
        </div>
        <!-- 吻合度 -->
        <div class="flex" style="height: 150px;position: relative;" v-show="tabActive==3">
          <div v-if="reportType==1" @click="switchEye()" class="switchMode" style="left: 10px;right: auto;">
            {{eyeModeText}}</div>
          <div class="btn" style="width: 20%;">
            <div>
              <span @click="boardTypeChange(0)" :class="{tab_active:boardType==0}">全盘</span>
              <span @click="boardTypeChange(1)" :class="{tab_active:boardType==1}">布局</span>
              <span @click="boardTypeChange(2)" :class="{tab_active:boardType==2}">中盘</span>
              <span @click="boardTypeChange(3)" :class="{tab_active:boardType==3}">官子</span>
            </div>
          </div>
          <div style="width: 80%;height: 150px;" id="hitHand"></div>
        </div>
        <div class="flex" style="height: 150px;" v-show="tabActive==4">
          <div class="btn" style="width: 20%;">
            <div>
              <span @click="boardTypeChange(0)" :class="{tab_active:boardType==0}">全盘</span>
              <span @click="boardTypeChange(1)" :class="{tab_active:boardType==1}">布局</span>
              <span @click="boardTypeChange(2)" :class="{tab_active:boardType==2}">中盘</span>
              <span @click="boardTypeChange(3)" :class="{tab_active:boardType==3}">官子</span>
            </div>
          </div>
          <div style="width: 80%;height: 150px;" id="scoreChart"></div>
        </div>
        <div class="flex" style="height: 150px;position: relative;margin: auto;" v-show="tabActive==5">
          <div @click="switchTongji()" class="switchMode" style="left: 10px;right: auto;">{{ tongjiText }}</div>
          <div v-show="tongjiFlag==2" style="width: 100%;height: 150px;" id="statisticsBox"></div>

          <div v-show="tongjiFlag==1" class="btn" style="width: 20%;">
            <div>
              <span @click="boardTypeChange(0)" :class="{tab_active:boardType==0}">全盘</span>
              <span @click="boardTypeChange(1)" :class="{tab_active:boardType==1}">布局</span>
              <span @click="boardTypeChange(2)" :class="{tab_active:boardType==2}">中盘</span>
              <span @click="boardTypeChange(3)" :class="{tab_active:boardType==3}">官子</span>
            </div>
          </div>
          <div v-show="tongjiFlag==1" style="width: 80%;height: 150px;" id="stableLine"></div>

        </div>
        <!-- 恶手报表 -->
        <div class="flex" style="height: 150px;" v-show="tabActive==7">
          <div class="btn" style="width: 18%;position: relative;">
            <div>
              <span @click="switchBad" class="tab_active">{{ showBadGroup?'筛选':'返回' }} </span>
            </div>
            <div>
              <span @click="playerTypeChange(0)" :class="{tab_active:playerType==0}">双方</span>
              <span @click="playerTypeChange(1)" :class="{tab_active:playerType==1}">黑方</span>
              <span @click="playerTypeChange(2)" :class="{tab_active:playerType==2}">白方</span>
            </div>
          </div>
          <div style="width: 82%;height: 150px;overflow-y: auto;padding-top: 3px;">
            <div v-if="!showBadGroup" class="badList">
              <div v-bind:key="item" v-for="item in badList">
                <div @click="ListGoTo(item)" v-on:mouseover="badActive=item.move" v-on:mouseout="badActive=''" class="badItem" :class="{recommendStoneSelected:badActive==item.move}">
                  <text class="text1">第<text style="font-size: 14px;padding: 0px 2px">{{item.move}}</text>手</text>
                  <text class="text2">
                    <text v-if="!item.bad_tag" class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;" :style="{'background-color': colorList[item.level]}"> {{item.mark}}</text>
                    <text v-else class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;" :style="{'background-color': colorList[item.level]}"> {{item.bad_tag}}</text>
                  </text>
                  <text class="text3">{{item.rate_diff.toFixed(1)+'%'}}</text>
                  <text class="text4">{{item.an_diff.toFixed(1)+'目'}}</text>
                </div>
                <div style="border-top: 0.5px solid #eaeaea;"></div>
              </div>
            </div>

            <div v-else class="badList">
              <div v-bind:key="item" v-for="item in bad_group" style="padding: 2px 0px">
                <div @click="badGroupTop(item)" v-on:mouseover="badGroupActive=item.key" v-on:mouseout="badGroupActive=''" class="badItem" :class="{recommendStoneSelected:badGroupActive==item.key}">
                  <text class="text1">
                    <text v-if="!item.bad_tag" class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;" :style="{'background-color': colorList[item.level]}"> {{item.mark}}</text>
                    <text v-else class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;" > {{item.bad_tag}}</text>
                  </text>
                  <text class="text2">共<text style="font-size: 14px;padding: 0px 2px">{{item.count}}</text>手</text>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 复杂度 -->
        <div style="height: 150px;width: 100%;" v-show="tabActive==8" id="complexChart"></div>

        <!-- 好手报表 -->
        <div class="flex" style="height: 150px;" v-show="tabActive==9">
          <div class="btn" style="width: 18%;position: relative;">
            <div>
              <span @click="switchBad" class="tab_active">筛选</span>
            </div>
            <div>
              <span @click="playerTypeChange(0)" :class="{tab_active:playerType==0}">双方</span>
              <span @click="playerTypeChange(1)" :class="{tab_active:playerType==1}">黑方</span>
              <span @click="playerTypeChange(2)" :class="{tab_active:playerType==2}">白方</span>
            </div>
          </div>
          <div style="width: 82%;height: 150px;overflow-y: auto;padding-top: 3px;">
            <div v-if="!showGoodGroup" class="badList">
              <div v-bind:key="item" v-for="item in goodList">
                <div @click="ListGoTo(item)" v-on:mouseover="goodActive=item.move" v-on:mouseout="goodActive=''" class="badItem" :class="{recommendStoneSelected:goodActive==item.move}">
                  <text class="text1">第<text style="font-size: 14px;padding: 0px 2px">{{item.move}}</text>手</text>
                  <text class="text2">
                    <text v-if="!item.good_tag" class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;" :style="{'background-color': colorList[item.level]}"> {{item.mark}}</text>
                    <text v-else class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;"> {{item.good_tag}}</text>
                  </text>
                  <text class="text3">{{item.rate_diff.toFixed(1)+'%'}}</text>
                  <text class="text4">{{item.an_diff.toFixed(1)+'目'}}</text>
                </div>
                <div style="border-top: 0.5px solid #eaeaea;"></div>
              </div>
            </div>

            <div v-else class="badList">
              <div v-bind:key="item" v-for="item in good_group" style="padding: 2px 0px">
                <div @click="GoodGroupTop(item)" v-on:mouseover="goodGroupActive=item.key" v-on:mouseout="goodGroupActive=''" class="badItem" :class="{recommendStoneSelected:goodGroupActive==item.key}">
                  <text class="text1">
                    <text v-if="!item.good_tag" class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;" :style="{'background-color': colorList[item.level]}"> {{item.mark}}</text>
                    <text v-else class="shizhan" style="padding: 0px 13px;font-size: 12px;border-radius: 3px;background-color:#d43dea ;"> {{item.good_tag}}</text>
                  </text>
                  <text class="text2">共<text style="font-size: 14px;padding: 0px 2px">{{item.count}}</text>手</text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 45px;"></div>
    <div class="anquanqu"></div>

    <div v-show="moreFlag" class="btn_list1">
      <div style="background: #d3d3d3;">
        <div v-if="reportType==1&&result.status==3" @click="boardFunc('pdf')" class="btn_div1">
          查看PDF
        </div>
        <div @click="boardFunc('tryMove')" class="btn_div1" :class="{'bgwhite':tryMoveFlag}">
          试下
        </div>
        <div @click="boardFunc('score')" class="btn_div1" :class="{'bgwhite':scoreFlag}">
          领地
        </div>
        <div @click="boardFunc('marker')" class="btn_div1" :class="{disableTest:tryMoveFlag}">
          手数
        </div>
        <div @click="boardFunc('showStone')" class="btn_div1" :class="{'bgwhite':showStone}">
          不提示
        </div>
      </div>
    </div>

    <div class="btn_list flex">
      <div v-on:touchstart="btntype='first'" v-on:touchend="btntype=''" @click="boardFunc('first')" class="btn_div"><img :class="{btnSelected:btntype=='first'}" src="@/assets/firstblue.png">
      </div>
      <div v-on:touchstart="btntype='previousfive'" v-on:touchend="btntype=''" @click="boardFunc('previousfive')" class="btn_div"><img :class="{btnSelected:btntype=='previousfive'}" src="@/assets/previousfiveblue.png">
      </div>
      <div v-on:touchstart="btntype='previous'" v-on:touchend="btntype=''" @click="boardFunc('previous')" class="btn_div"><img :class="{btnSelected:btntype=='previous'}" src="@/assets/previousblue.png">
      </div>
      <div v-on:touchstart="btntype='next'" v-on:touchend="btntype=''" @click="boardFunc('next')" class="btn_div"><img :class="{btnSelected:btntype=='next'}" src="@/assets/nextblue.png">
      </div>
      <div v-on:touchstart="btntype='nextfive'" v-on:touchend="btntype=''" @click="boardFunc('nextfive')" class="btn_div"><img :class="{btnSelected:btntype=='nextfive'}" src="@/assets/nextfiveblue.png">
      </div>
      <div v-on:touchstart="btntype='last'" v-on:touchend="btntype=''" @click="boardFunc('last')" class="btn_div"><img :class="{btnSelected:btntype=='last'}" src="@/assets/lastblue.png">
      </div>
      <div v-on:touchstart="btntype='more'" v-on:touchend="btntype=''" @click="boardFunc('more')" class="btn_div">
        <img :class="{btnSelected:btntype=='more'}" src="@/assets/more.png">
      </div>
    </div>
  </div>
</template>

<script>
import mobile from '@/js/index.js'
document.querySelector('html').setAttribute('style', 'background-color:#f2f2f2')
export default mobile
</script>
<style scoped>
.header {
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  background-color: #fff;
}

.header_l {
  display: flex;
  align-items: center;
  color: #4d77ab;
  font-size: 12px;
}

.header_l_img {
  width: 30px;
  height: 30px;
  padding-right: 10px;
}

.header_r {
  font-size: 12px;
  color: #808080;
  width: 70%;
  text-align: right;
  line-height: 1.2;
}

.game_info {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
}

.game_info > .title {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 25px;
  align-items: center;
  padding: 0px 10px;
  border-bottom: 1px solid #f2f2f2;
  box-sizing: border-box;
}

.game_info_detail .img {
  width: 15px;
  height: 15px;
}

.vs-line {
  height: 14px;
  border: 1px solid black;
  border-radius: 4px;
}

.vs-line-r {
  font-size: 11px;
  line-height: 14px;
}

.vs-line-l {
  font-size: 11px;
  line-height: 14px;
}

.board {
  background: url("~@/libs/ggo/board.jpg") no-repeat;
  background-position: center;
  background-size: cover;
}

.recommend {
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f2f2f2;
}

.recommend > .row {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  padding: 0px 10px;
}

.recommend > .row > :nth-child(1) {
  width: 30%;
}

.recommend > .row > :nth-child(2) {
  width: 30%;
  text-align: center;
}

.recommend > .row > :nth-child(3) {
  width: 30%;
  text-align: center;
}

.echarts_div {
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
}

.tab_title {
  display: flex;
  background-color: #f8f8f8;
  height: 25px;
}

.tab_title span {
  flex: 1;
  text-align: center;
  cursor: pointer;
  line-height: 25px;
  color: #4c4c4c;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.tab_active {
  background: #3399cc !important;
  color: #fff !important;
}

.btn_list1 {
  position: fixed;
  z-index: 990;
  padding: 2px;
  right: 3px;
  bottom: 45px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.btn_list1 .btn_div1 {
  width: 70px;
  height: 30px;
  background-color: #e1e1e1;
  color: #000;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  margin-top: 3px;
}

.btn_list {
  justify-content: space-around;
  height: 40px;
  z-index: 995;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  bottom: 0px;
  background: #e1e1e1;
  border-top: solid 1px rgba(20, 20, 20, 0.1);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.btn_list > .btn_div {
  font-size: 10px;
  text-align: center;
  color: #4c4c4c;
}

.btn_list > .btn_div > img {
  width: 30px;
  height: 30px;
}

.btnSelected {
  width: 28px !important;
  height: 28px !important;
  margin: 1px;
}

.switchMode {
  position: absolute;
  right: 10px;
  font-size: 11px;
  background-color: #3399cc;
  padding: 1px 5px;
  border-radius: 2px;
  top: 10px;
  z-index: 998;
  color: #fff;
}

.btn {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.btn > div > span {
  display: block;
  background-color: rgba(20, 20, 20, 0.7);
  color: rgba(255, 255, 255, 0.7);
  width: 40px;
  margin: 3px 0px;
  font-size: 11px;
  text-align: center;
  border-radius: 2px;
  padding: 0px 3px;
  box-sizing: border-box;
}

.recommendStone:hover {
  background-color: rgba(20, 20, 20, 0.5);
}

.anquanqu {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.recommendStoneSelected {
  background-color: #38b745;
  color: #fff;
}

.disableBtn {
  filter: grayscale(100%);
}

.loading_box {
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  z-index: 999;
}

.fade_out {
  animation: fadeOut 3s;
  -moz-animation: fadeOut 3s;
  /* Firefox */
  -webkit-animation: fadeOut 3s;
  /* Safari and Chrome */
  -o-animation: fadeOut 3s;
  /* Opera */
}

.head {
  border-radius: 100%;
  width: 40px;
}

.shizhan {
  height: 14px;
  line-height: 14px;
  font-size: 11px;
  width: 50px;
  text-align: center;
  border-radius: 2px;
  margin-left: 5px;
  color: #fff;
}

.shizhanBorder {
  border-radius: 3px;
  box-sizing: border-box;
  border: 0.5px solid red;
}

.scoreResult {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  z-index: 999;
  text-align: center;
  color: #fff;
}

.disableTest {
  color: #808080 !important;
}

.badList {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 95%;
  padding: 5px 0px 10px 0px;
  box-sizing: border-box;
}

.badItem {
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: space-around;
  padding: 0px 5px;
}

.text1 {
  width: 30%;
  font-size: 12px;
}

.text2 {
  width: 30%;
  text-align: center;
}

.text3 {
  width: 25%;
  text-align: center;
}

.text4 {
  width: 25%;
  text-align: right;
}
.fuzadu {
  font-size: 11px;
  color: #fff;
  padding: 0px 4px;
  height: 26rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  width: 80px;
}
</style>